import React, { useEffect, useState } from 'react'
import ReactTable from 'react-table'
import { Button, Card, CardBody, CardFooter, CardHeader, Col, Container, DatePicker, FormInput, FormSelect, InputGroup, InputGroupAddon, InputGroupText, ListGroupItem, Row } from 'shards-react'
import ConfirmAlert from '../../../components/common/ConfirmAlert'
import { setDateForTable, setInputDate } from '../../../utils/date'
import { formatNumberAmount } from '../../../utils/general'
import { useHistory, useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { NavgationPageLocationKey } from '../../../utils/constants'
import { connect } from 'react-redux'
import classNames from 'classnames'
import CustomModal from '../../../components/common/CustomModal'
import { download_client_balance, get_cli_balance_summary, get_cli_worker_retainers } from '../../../redux/actions/subscriber/subscriberUsers'

const ClientBalanceDetails = ({
    changePageMeta, get_cli_worker_retainers, clientRetainerDetails, 
    get_cli_balance_summary, clientBalanceDetails, 
    download_client_balance,
}) => {
    const [initialState, setInitialState] = useState({
        refNum: 0,
        outstandingInvoices: 0,
        unallocatedPayments: 0,
        retainerRequired: 0,
        retainerHeld: 0,
        retainerInvoiced: 0,
        maxRetainer: 0,
        totalARBalance: 0,
        totalRetainerInvoiced: 0,
        totalClientBalance: 0,
        totalOutstandingBalance: 0,

        workerRef: '',
        worker: '',
        from: '',
        to: '',
        pageSizeOptions: [5, 10, 15, 20, 25, 30],
        pageSize: 20,
    })

    const [formData, setFormData] = useState(initialState)
    const location = useLocation();
    const [stateId, setStateId] = useState(0);
    const history = useHistory();
    const [tableItemData, setTableItemData] = useState([]);
    const [tableData, setTableData] = useState([]);

    const [openModal, setOpenModal] = useState(false);
    const [openAllocationModal, setOpenAllocationModal] = useState(false);

    // Added by nipul for parameter less flow
    function navigateToUser(e, workerId){
        e.preventDefault(); 
        history.push({
            pathname: `/manage-user-profile/` + `${workerId}`,
            //state: { refNum: refId, clientName: clientName }
        });
        return false;
    }

    function onContextMenuUser(e, workerId){
        if(e.type === 'contextmenu'){
            return false;
            //localStorage.setItem(NavgationPageLocationKey.clientBalanceUserId, workerId);
        }
    }

    const tableColumns = [
        {
            Header: "Worker ID",
            accessor: "workerId",
            minWidth: 70,
            Cell: row => <a href="/manage-user-profile" 
                onClick={(e) => { navigateToUser(e, row.original.workerId)}}
                onContextMenu={(e) => onContextMenuUser(e, row.original.workerId)}>
                {row.original.workerId}
            </a>,
            Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>Total</span>
            </div>
        },
        {
            Header: "Worker",
            accessor: "workerName",
            minWidth: 200,
            Cell: row => <span className="w-100 text-left">{row.original.workerName}</span>,
        },
        {
            Header: "Hire Date",
            accessor: "hireDate",
            minWidth: 80,
            Cell: row => setDateForTable(row.original.hireDate)
        },
        {
            Header: "Termination Date",
            accessor: "terminationDate",
            minWidth: 90,
            Cell: row => setDateForTable(row.original.terminationDate)
        },
        {
            Header: "Retainer Required",
            accessor: "retainerRequired",
            minWidth: 130,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.retainerRequired, 'en-US', 2, 2)}</span>,
            Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(tableData.totalRetainerRequired, 'en-US', 2, 2)}</span>
            </div>
            
        },
        {
            Header: "Retainer Held",
            accessor: "retainerHeld",
            minWidth: 100,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.retainerHeld, 'en-US', 2, 2)}</span>,
            Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(tableData.totalRetainerHeld, 'en-US', 2, 2)}</span>
            </div>
        },
        {
            Header: "Retainer Invoiced",
            accessor: "retainerInvoiced",
            minWidth: 130,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.retainerInvoiced, 'en-US', 2, 2)}</span>,
            Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(tableData.totalRetainerInvoiced, 'en-US', 2, 2)}</span>
            </div>
        },
        {
            Header: "Retainer to Invoice",
            accessor: "retainerToInvoice",
            minWidth: 100,
            Cell: row => <span className="w-100 text-right">{formatNumberAmount(row.original.retainerToInvoice, 'en-US', 2, 2)}</span>,
            Footer: <div className="d-flex w-100 justify-content-end text-nowrap">
                <span>{formatNumberAmount(tableData.totalRetainerToInvoice, 'en-US', 2, 2)}</span>
            </div>
        },
    ]

    const reset = () => {
        setFormData({ ...initialState });
        //Need to change the objcect name
        get_cli_worker_retainers(stateId, "", "", "", "")
    }

    const onSearch = (e) => {
        e.preventDefault()
        get_cli_worker_retainers(stateId, formData.workerRef, formData.worker
            , setInputDate(formData.from), setInputDate(formData.to))
    }

    const onChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const onPageGuideToggle = (e) => {
        setOpenAllocationModal(!openAllocationModal);
    }

    useEffect(() => {
        if (stateId === 0) {
            if (location.state !== undefined && location.state !== null) {
                //Take from state
                setStateId(location.state?.refNum);
                changePageMeta(`${(location.state?.clientName + ` - Balances`)}`, "", true, onPageGuideToggle)  
                get_cli_balance_summary(location.state?.refNum);
                get_cli_worker_retainers(location.state?.refNum, "", "", "", "");
            }
            else if (localStorage.getItem(NavgationPageLocationKey.clientBalanceAddEdit) !== null) {
                //Take from local storage 
                setStateId(localStorage.getItem(NavgationPageLocationKey.clientBalanceAddEdit));
                //get_automation_process_details(localStorage.getItem(NavgationPageLocationKey.AutomationLogAddEdit), '', '', '', '', '', '', '', '')
                const newState = { refNum: localStorage.getItem(NavgationPageLocationKey.clientBalanceAddEdit)
                    , clientName: localStorage.getItem(NavgationPageLocationKey.clientBalanceClientName) };
                    
                get_cli_worker_retainers(newState.refNum, "", "", "", "");
                get_cli_balance_summary(newState.refNum);
                history.push(location.pathname, newState);
                changePageMeta(`${(newState?.clientName + ` - Balances`)}`, "", true, onPageGuideToggle)
                localStorage.removeItem(NavgationPageLocationKey.clientBalanceAddEdit);
                localStorage.removeItem(NavgationPageLocationKey.clientBalanceClientName);
            }
            // else {
            //     //For testing only
            //     changePageMeta(`${(`Sample Check Else- Balance`)}`, "", true, onPageGuideToggle)
            // }
        }
    }, []);

    const toggleAllocation = () => {
        setOpenAllocationModal(!openAllocationModal);
    }

    const downloadBalanceDetails = (e) => {
        e.preventDefault();
        download_client_balance(stateId);
    }

    useEffect(() => {

        setFormData({ ...formData, outstandingInvoices: clientBalanceDetails.outstandingInvoices
            , unallocatedPayments: clientBalanceDetails.unallocatedPayments
            , retainerRequired: clientBalanceDetails.retainerRequired
            , retainerHeld: clientBalanceDetails.retainerHeld
            , retainerInvoiced: clientBalanceDetails.retainerInvoiced
            , totalARBalance: clientBalanceDetails.totalARBalance
            , totalRetainerInvoiced: clientBalanceDetails.retainerToInvoice
            , totalClientBalance: clientBalanceDetails.clientBalance
            , totalOutstandingBalance: clientBalanceDetails.outstandingBalance
            , maxRetainer: clientBalanceDetails.maxReatiner
        })
        //console.log("clientBalanceDetails =>", clientBalanceDetails)
    }, [clientBalanceDetails])

    useEffect(() => {
        var revisedObject = {
            data: clientRetainerDetails.workerRetainers,
            totalRetainerHeld: clientRetainerDetails.totalRetainerHeld,
            totalRetainerInvoiced: clientRetainerDetails.totalRetainerInvoiced,
            totalRetainerRequired: clientRetainerDetails.totalRetainerRequired,
            totalRetainerToInvoice: clientRetainerDetails.totalRetainerToInvoice,
        } 
        setTableData({...revisedObject});
    }, [clientRetainerDetails])

    const closeButtonAllocation = <span className="d-flex flex-row justify-content-between">
        <Button onClick={toggleAllocation} className="px-4 my-2">Cancel</Button>
    </span>

    const navigateToInvoice = () => {
        localStorage.setItem(NavgationPageLocationKey.outstandingInvoice, location.state?.clientName);
    }

    const navigateToPayment = () => {
        localStorage.setItem(NavgationPageLocationKey.unallocatedPayments, location.state?.clientName);
    }

    return (
        <Container fluid className="main-content-container px-4 pb-4 bg-white mt-2">
            <CustomModal toggle={toggleAllocation} openModal={openAllocationModal}
                headerTitle={<span><span>{`Balance Summary Guide`}</span></span>}
                footerComponent={closeButtonAllocation} className="lg-modal client-balance client_Balance_Popup"
                footerClasses="d-flex flex-row justify-content-center border-top-0"
                showCloseIcon={false}
                setRightHeaderStyle={true}
                rightHeaderWidth="50.5%"
                customSize="client_Balance_Popup"
                //customBodyClass="client_balance_body_height"
            >
                <Container fluid className="main-content-container pt-2 pl-4 ">
                    <Row className="border-bottom">
                        <Col lg="4">
                            <span> Field Name </span>
                        </Col>
                        <Col lg="8">
                            <span> Description </span>
                        </Col>
                    </Row>

                    <Row className="border-bottom pt-2">
                        <Col lg="4">
                            <span> Unallocated Payments </span>
                        </Col>
                        <Col lg="8">
                            <label>Received Payments waiting to be allocated + Credit Memos</label>
                        </Col>
                    </Row>
                    <Row className="border-bottom pt-2">
                        <Col lg="4">
                            <span> Total AR Balance </span>
                        </Col>
                        <Col lg="8">
                            <label> Outstanding Invoices - Unallocated Payments </label>
                        </Col>
                    </Row>
                    <Row className="border-bottom pt-2">
                        <Col lg="4">
                            <span> Retainer Held </span>
                        </Col>
                        <Col lg="8">
                            <label> Actual Retainer Payment received </label>
                        </Col>
                    </Row>
                    <Row className="border-bottom pt-2">
                        <Col lg="4">
                            <span> Retainer Invoiced </span>
                        </Col>
                        <Col lg="8">
                            <label> Retainer Invoice Payment not received </label>
                        </Col>
                    </Row>
                    <Row className="border-bottom pt-2">
                        <Col lg="4">
                            <span> Outstanding Invoices </span>
                        </Col>
                        <Col lg="8">
                            <label> The total of unpaid Invoices including Retainers Invoiced. If a Payable exists, it will appear as a negative Invoice, indicating a reduction in the outstanding amount  </label>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col lg="12">
                            <span> Calculation Logic for "Retainer to Invoice" </span>
                        </Col>
                    </Row>
                    <Row className="mt-3">
                        <Col lg="8">
                            <div>
                                <div>
                                    <label> If Retainer Held + Retainer Invoiced is less then the lower of (Max. Retainer or Retainer </label>
                                </div>
                                <div>
                                    <label>Required), then:</label>
                                    <div className='pl-4 border-left'>
                                        <div>
                                            <label> Additional Retainer Needed = </label>
                                        </div>
                                        <div>
                                            <label> the lower of (Max. Retainer or Retainer Required) </label>
                                        </div>
                                        <div>
                                            <label> - (Retainer Held + Retainer Invoiced) </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <label> Example: </label>
                                </div>
                                <div>
                                    <label>If 6,000.00 + 5,000.00 is less than the lower of 100,000.00 or 12,000.00, then: </label>
                                    <div className='pl-4 border-left'>
                                        <div>
                                            <label> Additional Retainer Needed = </label>
                                        </div>
                                        <div>
                                            <label> the lower of 100,000.00 or 12,000.00 </label>
                                        </div>
                                        <div>
                                            <label> - (6,000.00 + 5,000.00), otherwise 0 </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div>
                                <div>
                                    <label>= If 11,000.00 {'<'} 12,000.00, then: </label>
                                    <div className='pl-4 border-left'>
                                        <div>
                                            <label> ARN = 12,000.00 - 11,000.00, otherwise 0 </label>
                                        </div>
                                        <div>
                                            <label> = 1,000.00 </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>

            </CustomModal>
            <Card>
                <CardHeader className="px-4" >
                    <Row className="pl-0">
                        <Col>
                            <Button className="mx-2 py-2 my-2" size='sm' name="Download" theme="accent" onClick={downloadBalanceDetails}>
                                <i class="fa fa-download" aria-hidden="true"></i> Download
                            </Button>
                        </Col>
                    </Row>
                    <Row>
                        <Col className="pb-2 pt-2">
                            Balance Summary
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="3">
                            <Card className="py-1 my-1" lg="3" style={{ height: "93%" }}>
                                <CardHeader className="pl-3 pt-3 pb-0">
                                    <b>AR Balance</b>
                                </CardHeader>
                                <CardBody className="pb-0 px-3 pt-3">
                                    <div className='d-flex'>
                                        <div style={{ width: "75%" }}>
                                            <i class="fa fa-plus" aria-hidden="true" style={{ color: "green" }}></i> 
                                            <label className='mb-0'>
                                                <a href='/view-invoices' target='_blank' onClick={() => navigateToInvoice()}> &nbsp; Outstanding Invoices:</a>
                                            </label>
                                            
                                        </div>
                                        <div className='text-right' style={{ width: "25%" }}>
                                            <label className='mb-0'>{formatNumberAmount(formData.outstandingInvoices, 'en-US', 2, 2)}</label>
                                        </div>
                                    </div>
                                    <div className='d-flex'>
                                        <div style={{ width: "75%" }}>
                                            <i class="fa fa-minus" aria-hidden="true" style={{ color: "red" }}></i> 
                                            <label className='mb-0'>
                                                <a href='/view-payments' target='_blank' onClick={() => navigateToPayment()}> &nbsp; Unallocated Payments:</a>
                                            </label>
                                        </div>
                                        <div className='text-right' style={{ width: "25%" }}>
                                            <label className='mb-0'>{formatNumberAmount(formData.unallocatedPayments, 'en-US', 2, 2)}</label>
                                        </div>
                                    </div>
                                </CardBody>
                                <CardFooter className='pt-0 pl-3 pr-3 pb-3'>
                                    <div className='d-flex'>
                                        <div style={{ width: "70%" }}>
                                            <i class="fa fa-equals" aria-hidden="true"></i>
                                            <span> Total AR Balance:</span>
                                        </div>
                                        <div className='text-right' style={{ width: "30%" }}>
                                            <span> {formatNumberAmount(formData.totalARBalance, 'en-US', 2, 2)} </span>
                                        </div>
                                    </div>
                                </CardFooter>
                            </Card>
                        </Col>
                        <Col lg="3">
                            <Card className="py-1 my-1" lg="3" style={{ height: "93%" }}>
                                <CardHeader className="px-3 pb-0">
                                    <b>Retainer (Max. Retainer: {formatNumberAmount(formData.maxRetainer, 'en-US', 2, 2)})</b>
                                </CardHeader>
                                <CardBody className="pb-0 px-3 pt-3 no-OverFlow">
                                    <div className='d-flex'>
                                        <div style={{ width: "75%" }}>
                                            <i class="fa fa-plus" aria-hidden="true" style={{ color: "green" }}></i> <label className='mb-0'>Retainer Required:</label> 
                                        </div>
                                        <div className='text-right' style={{ width: "25%" }}>
                                            <label className='mb-0'>{formatNumberAmount(formData.retainerRequired, 'en-US', 2, 2)}</label>
                                        </div>
                                    </div>
                                    <div className='d-flex'>
                                        <div style={{ width: "75%" }}>
                                            <i class="fa fa-minus" aria-hidden="true" style={{ color: "red" }}></i> <label className='mb-0'>Retainer Held:</label> 
                                        </div>
                                        <div className='text-right' style={{ width: "25%" }}>
                                            <label className='mb-0'>{formatNumberAmount(formData.retainerHeld, 'en-US', 2, 2)}</label>
                                        </div>
                                    </div>
                                    <div className='d-flex'>
                                        <div style={{ width: "75%" }}>
                                            <i class="fa fa-minus" aria-hidden="true" style={{ color: "red" }}></i> <label className='mb-0'>Retainer Invoiced:</label>
                                        </div>
                                        <div className='text-right' style={{ width: "25%" }}>
                                            <label className='mb-0'>{formatNumberAmount(formData.retainerInvoiced, 'en-US', 2, 2)}</label>
                                        </div>
                                    </div>
                                </CardBody>
                                <CardFooter className='pt-1 pl-3 pr-3 pb-3'>
                                    <div className='d-flex'>
                                        <div style={{ width: "70%" }}>
                                            <i class="fa fa-equals" aria-hidden="true"></i>
                                            <span> Retainer to Invoice:</span>
                                        </div>
                                        <div className='text-right' style={{ width: "30%" }}>
                                            <span> {formatNumberAmount(formData.totalRetainerInvoiced, 'en-US', 2, 2)} </span>
                                        </div>
                                    </div>
                                </CardFooter>
                            </Card>
                        </Col>
                        <Col lg="3">
                            <Card className="py-1 my-1" lg="3" style={{ height: "93%" }}>
                                <CardHeader className="pl-3 pt-3 pb-0">
                                    <b>Client Balance</b>
                                </CardHeader>
                                <CardBody className="pb-0 px-3 pt-3">
                                    <div className='d-flex'>
                                        <div style={{ width: "75%" }}>
                                            <i class="fa fa-plus" aria-hidden="true" style={{ color: "green" }}></i> <label className='mb-0'>Retainer Held:</label>
                                        </div>
                                        <div className='text-right' style={{ width: "25%" }}>
                                            <label className='mb-0'>{formatNumberAmount(formData.retainerHeld, 'en-US', 2, 2)}</label>
                                        </div>
                                    </div>
                                    <div className='d-flex'>
                                        <div style={{ width: "75%" }}>
                                            <i class="fa fa-plus" aria-hidden="true" style={{ color: "green" }}></i> <label className='mb-0'>Unallocated Payments:</label>
                                        </div>
                                        <div className='text-right' style={{ width: "25%" }}>
                                            <label className='mb-0'>{formatNumberAmount(formData.unallocatedPayments, 'en-US', 2, 2)}</label>
                                        </div>
                                    </div>
                                </CardBody>
                                <CardFooter className='pt-1 pl-3 pr-3 pb-3'>
                                    <div className='d-flex'>
                                        <div style={{ width: "70%" }}>
                                            <i class="fa fa-equals" aria-hidden="true"></i>
                                            <span> Client Balance:</span>
                                        </div>
                                        <div className='text-right' style={{ width: "30%" }}>
                                            <span> {formatNumberAmount(formData.totalClientBalance, 'en-US', 2, 2)} </span>
                                        </div>
                                    </div>
                                </CardFooter>
                            </Card>
                        </Col>
                        <Col lg="3">
                            <Card className="py-1 my-1" lg="3" style={{ height: "93%" }}>
                                <CardHeader className="pl-3 pt-3 pb-0">
                                    <b>Outstanding Balance</b>
                                </CardHeader>
                                <CardBody className="pb-0 px-3 pt-3 no-OverFlow">
                                    <div className='d-flex'>
                                        <div style={{ width: "75%" }}>
                                            <i class="fa fa-plus" aria-hidden="true" style={{ color: "green" }}></i> <label className='mb-0'>Outstanding invoices:</label>
                                        </div>
                                        <div className='text-right' style={{ width: "25%" }}>
                                            <label className='mb-0'>{formatNumberAmount(formData.outstandingInvoices, 'en-US', 2, 2)}</label>
                                        </div>
                                    </div>
                                    <div className='d-flex'>
                                        <div style={{ width: "75%" }}>
                                            <i class="fa fa-plus" aria-hidden="true" style={{ color: "green" }}></i> <label className='mb-0'>Retainer to Invoice:</label>
                                        </div>
                                        <div className='text-right' style={{ width: "25%" }}>
                                            <label className='mb-0'>{formatNumberAmount(formData.totalRetainerInvoiced, 'en-US', 2, 2)}</label>
                                        </div>
                                    </div>
                                    <div className='d-flex'>
                                        <div style={{ width: "75%" }}>
                                            <i class="fa fa-minus" aria-hidden="true" style={{ color: "red" }}></i> <label className='mb-0'>Client Balance:</label>
                                        </div>
                                        <div className='text-right' style={{ width: "25%" }}>
                                            <label className='mb-0'>{formatNumberAmount(formData.totalClientBalance, 'en-US', 2, 2)}</label>
                                        </div>
                                    </div>
                                </CardBody>
                                <CardFooter className='pt-1 pl-3 pr-3 pb-3'>
                                    <div className='d-flex'>
                                        <div style={{ width: "70%" }}>
                                            <i class="fa fa-equals" aria-hidden="true"></i>
                                            <span> Outstanding Balance:</span>
                                        </div>
                                        <div className='text-right' style={{ width: "30%" }}>
                                            <span> {formatNumberAmount(formData.totalOutstandingBalance, 'en-US', 2, 2)} </span>
                                        </div>
                                    </div>
                                </CardFooter>
                            </Card>
                        </Col>
                    </Row>
                </CardHeader>

                <CardBody className="paddingtopzero w-100">
                    <Row>
                        <Col className="pb-2 pt-2">
                            Worker Retainers
                        </Col>
                    </Row>
                    <div className="page-header tableSearch flex-column flex-md-row py-2 d-flex bg-white mt-4 ">

                        <div className="d-flex align-items-center p-2">
                            <FormInput
                                name='workerRef' value={formData.workerRef}
                                onChange={onChange} placeholder="Worker ID"
                            />
                        </div>

                        <div className="d-flex align-items-center p-2">
                            <FormInput
                                name='worker' value={formData.worker}
                                onChange={onChange} placeholder="Worker"
                            />
                        </div>

                        <div className="d-flex align-items-center p-2">
                            <div className="d-flex align-items-center p-2">
                                <InputGroup className={classNames("d-flex", "my-auto", "date-range")}>
                                    <DatePicker
                                        name="from"
                                        size="sm"
                                        selected={formData.from}
                                        onChange={(date) => {
                                            setFormData({ ...formData, from: date })
                                        }}
                                        dateFormat='yyyy-MM-dd'
                                        placeholderText="Start Date"
                                        dropdownMode="select"
                                        autoComplete='off'
                                        className="text-center"
                                        popperPlacement="bottom-start"
                                    />
                                    <DatePicker
                                        name="to"
                                        size="sm"
                                        selected={formData.to}
                                        onChange={(date) => {
                                            setFormData({ ...formData, to: date })
                                        }}
                                        dateFormat='yyyy-MM-dd'
                                        placeholderText="End Date"
                                        dropdownMode="select"
                                        autoComplete='off'
                                        className="text-center"
                                        popperPlacement="bottom-start"
                                        //popperPlacement="top-end"
                                    />
                                    <InputGroupAddon type="append">
                                        <InputGroupText>
                                            <i className="material-icons">&#xE916;</i>
                                        </InputGroupText>
                                    </InputGroupAddon>
                                </InputGroup>
                            </div>
                        </div>

                        <div className="d-flex align-items-center justify-content-end p-2">
                            <Button className="mx-2 py-2 my-2" size='sm' name="Search" theme="accent"
                                onClick={onSearch}>Search</Button>
                            <Button className="mx-2 py-2 my-2" size='sm' theme="accent" onClick={reset} >
                                Reset
                            </Button>
                        </div>
                    </div>
                    <Card className="tableCard p-0">
                        <CardHeader className="p-0">
                            <Container fluid className="file-manager__filters border-bottom">
                                <Row>
                                    {/* Filters :: Page Size */}

                                    <Col lg="2" className="file-manager__filters__rows d-flex justify-content-center justify-content-md-start align-items-center cl-2">
                                        {/* <span>
                                            <FormSelect size="sm" name='bulkAction' className="w-100"
                                                value={formData.bulkAction} onChange={onChange}
                                            >
                                                <option key="bulkActions0" value="">Bulk Actions</option>
                                                <option key="download2" value={DOWNLOAD}>Download</option>
                                                <option key="changeStatus1" value={CHANGE_STATUS}>Change Status</option>
                                            </FormSelect>
                                        </span> */}
                                    </Col>
                                    <Col lg="3" className="d-flex align-items-center">
                                    </Col>
                                    <Col lg="6" className="file-manager__filters__search d-flex justify-content-md-start col-7">
                                    </Col>

                                    <Col lg="1"
                                        className="file-manager__filters__rows d-flex justify-content-center justify-content-md-end align-items-center col-2">
                                        <span>Show</span>
                                        <FormSelect
                                            size="sm"
                                            name='pageSize'
                                            value={formData.pageSize}
                                            onChange={onChange}
                                        >
                                            {formData.pageSizeOptions.map((size, idx) => (
                                                <option key={idx} value={size}>
                                                    {size} rows
                                                </option>
                                            ))}
                                        </FormSelect>
                                    </Col>
                                </Row>
                            </Container>
                        </CardHeader>
                        <CardBody className="p-0">
                            <div className="">
                                <ReactTable
                                    columns={tableColumns}
                                    data={tableData.data}
                                    pageSize={Number(formData.pageSize)}
                                    showPageSizeOptions={false}
                                    resizable={false}
                                    noDataText="No results found"
                                    previousText={<i class='fa fa-chevron-left' aria-hidden='true'></i>}
                                    nextText={<i class='fa fa-chevron-right' aria-hidden='true'></i>}
                                />
                            </div>
                        </CardBody>
                    </Card>
                </CardBody>
            </Card>
        </Container>
    )
}

const mapStateToProps = (state) => ({
    clientRetainerDetails: state.subscriberUsers.clientRetainerDetails,
    clientBalanceDetails: state.subscriberUsers.clientBalanceDetails,
});

export default connect(mapStateToProps, {
    get_cli_worker_retainers,
    get_cli_balance_summary,
    download_client_balance,
})(ClientBalanceDetails);
